// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"3ae98575","769":"448cd256"}[chunkId] + ".chunk.css";
};